module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/elegant-616a2f97415b6dcb675bcff930341811.jpg";